<nav class="navigation-list">
  <ul class="nav-list">
    @for (item of filteredNavigationItems(); track item.id) {
      <li class="nav-list__item">
        <ng-template #navContent>
          <span class="nav-item__icon outlaw-icon" [class]="item.icon"></span>
          <span class="nav-item__label">{{ item.label }}</span>
        </ng-template>

        @if (item?.isExternal) {
          <a
            class="nav-item is-link"
            [href]="item.route"
            target="_blank"
            rel="nofollow"
          >
            <ng-container *ngTemplateOutlet="navContent" />
          </a>
        } @else if (item.route) {
          <a
            class="nav-item is-link"
            [routerLink]="item.route"
            [routerLinkActive]="['nav-item--active']"
            [routerLinkActiveOptions]="{
              exact: item.route === '/' || item.route === '/profile'
            }"
            [dataTest]="item.dataTest"
            (click)="onNavigationClick(item); $event.preventDefault()"
          >
            <ng-container *ngTemplateOutlet="navContent" />
          </a>
        } @else {
          <div
            class="nav-item nav-item--disabled"
            [matTooltip]="item.disabledHint || ''"
            [matTooltipShowDelay]="250"
            matTooltipClass="navigation-tooltip"
            [dataTest]="item.dataTest"
          >
            <ng-container *ngTemplateOutlet="navContent" />
          </div>
        }
      </li>
    }
  </ul>
</nav>
